// extracted by mini-css-extract-plugin
export var fullDivider = "_redotech-redo-customer-portal-app-src-portal-four-submission-components-summary-card-full-divider";
export var infoIcon = "_redotech-redo-customer-portal-app-src-portal-four-submission-components-summary-card-info-icon";